import { j as e } from "./jsx-runtime-e6RZPHeG.js";
import { memo as s } from "react";
const i = ({
  title: l,
  titleId: o,
  ...r
}) => /* @__PURE__ */ e.jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 1024 1024",
    role: "img",
    "aria-labelledby": o,
    ...r,
    children: [
      l ? /* @__PURE__ */ e.jsx("title", { id: o, children: l }) : null,
      /* @__PURE__ */ e.jsx(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M737.065 182.34h-448c-23.552 0-42.667 19.115-42.667 42.667s19.115 42.667 42.667 42.667h448c23.552 0 42.667-19.115 42.667-42.667s-19.115-42.667-42.667-42.667m23.093 315.209L539.785 319.842c-7.68-6.4-17.28-9.6-26.667-9.6-9.6 0-18.987 3.2-26.88 9.6L265.865 497.549c-18.347 14.72-21.12 41.6-6.4 59.968 14.72 18.325 41.6 21.333 59.947 6.379l151.04-121.813v359.04c0 23.467 18.987 42.667 42.667 42.667 23.467 0 42.667-19.2 42.667-42.667v-359.04l150.827 121.813c18.347 14.955 45.227 11.947 60.16-6.379 14.72-18.368 11.733-45.248-6.613-59.968z",
          clipRule: "evenodd"
        }
      )
    ]
  }
), m = s(i);
export {
  m as default
};
